import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './task.types';
import * as constants from './task.constants';

export const taskReducer = generateResourceReducer<types.ITask>({
  STORE: constants.STORE_TASK,
  CLEAR: constants.CLEAR_TASK,
});
